<template>
    <div>          
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label>Empresa</label>
                        <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" 
                        optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                            @change="listarCentrosCustos"/>
                    </div>                      
                </div>
            </div>
            <div class="p-col-12 p-md-6">
                <div class="p-fluid p-formgrid p-grid">                            
                    <div class="p-field p-col-9">
                        <label>Centro de custo</label>               
                        <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" 
                        optionLabel="nome" optionValue="id" placeholder="Todos"
                            :filter="true" :showClear="true"/>
                    </div> 
                    <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Buscar" icon="pi pi-search" @click="listarPorFiltros()"/>
                    </div>   
                    <div class="p-field p-col-9 p-md-9">                        
                        <div class="p-inputgroup">
                            <InputText v-model.trim="crachaNome" 
                            @keyup.enter="listarPorFiltros()" 
                            @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')" 
                            placeholder="crachá/pis/cpf/nome"/>
                            <Button icon="pi pi-search" title="Buscar" @click="listarPorFiltros()"/>                    
                        </div>
                    </div>          
                </div>
            </div>
        </div>
        <DataTable :value="funcionarios" class="p-datatable-sm p-datatable-striped">            
            <Column field="cracha" header="Crachá"></Column>
            <Column field="nome" header="Nome"></Column>
            <Column field="cargo" header="Cargo"></Column>
            <Column field="centroCusto" header="Centro de Custo"></Column>	
            <Column field="escala" header="Escala"></Column>	
            <Column field="dataCadastro" header="Cadastro"></Column>	
            <Column>
                <template #body="slotProps">
                    <Button icon="pi pi-clock" title="Lançar Saldo" class="p-button-rounded p-button-primary p-mr-2"
                        @click="selecionar(slotProps.data)"/>						
                </template>
            </Column>
        </DataTable>
        <Paginacao ref="paginacao" :qtdLinhasPorPagina="[10,15,20,30]" :callback="listarPorPagina"/> 

        <Dialog :visible.sync="exibirDialogSaldos" header="Saldos" :modal="true" :style="{width: '50vw'}">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-3">
                    <label>Período</label>
                    <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" 
                    :showIcon="true" :manualInput="false" :yearNavigator="true" 
                    :yearRange="rangeData" :locale="localeCalendarBR" appendTo="body"
                    @date-select="listarSaldos"/>				
                </div>
            </div>
            <DataTable :value="saldos" class="p-datatable-sm p-datatable-striped">
                <template #header>
                    <div class="table-header">			
                        <div class="p-d-flex p-jc-between">			
                            <Button label="Novo" icon="pi pi-plus" :disabled="funcionarioSelecionado.id == null" 
                            v-if="permissaoEditar" @click="novo"/>	
                            <label>{{ funcionarioSelecionado.cracha }} {{ funcionarioSelecionado.nome }}</label>
                        </div>
                    </div>
                </template>
                <Column field="data" header="Data">
                    <template #body="slotProps">
                        {{ formatarStringData(slotProps.data.data) }}
                    </template>
                </Column>
                <Column field="horas" header="Valor">
                    <template #body="slotProps">
                        <span :class="slotProps.data.valorNegativo ? 'negativo' : ''">
                        {{ formatarHoras(slotProps.data) }}
                        </span>
                    </template>	
                </Column>				
                <Column>
                    <template #body="slotProps">
                        <Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" 
                        @click="editar(slotProps.data)" v-if="permissaoEditar"/>
                        <Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger"
                        @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
                    </template>
                </Column>
            </DataTable> 
            <template #footer>
                <Button label="OK" icon="pi pi-check" class="p-button-primary" @click="exibirDialogSaldos=false"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogNovoSaldo" :header="tituloModal" :modal="true" class="p-fluid" :style="{width: '350px'}">			
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label for="data">Data</label>
                    <InputText :placeholder="formatarStringData(saldoBancoHoras.data)" v-if="saldoBancoHoras.id" disabled/>
                    <Dropdown v-model.trim="saldoBancoHoras.data" :options="datas" appendTo="body" 
                    optionLabel="nome" optionValue="id" :filter="true" :showClear="true" v-else/>
                </div>					
            </div>	
            <div class="p-fluid p-formgrid p-grid">					
                <div class="p-field p-col">
                    <label for="horas">Horas</label>
                    <InputNumber id="horas" v-model.number="saldoBancoHoras.horas" :useGrouping="false"/>
                    <small class="p-invalid" v-if="enviandoForm && saldoBancoHoras.horas==null">
                        Informe a quantidade de horas</small>
                </div>
                <div class="p-field p-col">
                    <label for="minutos">Minutos</label>
                    <InputText id="minutos" v-model="saldoBancoHoras.minutos" 
                    :useGrouping="false" @keyup="limitarMinutos"/>
                    <small class="p-invalid" v-if="enviandoForm && saldoBancoHoras.minutos==null">
                        Informe a quantidade de minutos</small>
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">					
                <div class="p-field-checkbox p-ml-2">
                    <Checkbox id="negativo" v-model="saldoBancoHoras.valorNegativo" :binary="true"/>
                    <label for="negativo">Negativo</label>
                </div>
            </div>  			
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogNovoSaldo=false"/>
                <Button label="Salvar" icon="pi pi-check" @click="salvar"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Excluir saldo de banco de horas?</span>                                   
                <p>
                    <br/>
                    Data: <b>{{ formatarStringData(saldoBancoHoras.data) }}</b><br/>
                    Saldo: <b :class="saldoBancoHoras.valorNegativo ? 'negativo' : ''">{{ formatarHoras(saldoBancoHoras) }}</b><br/>                            
                </p>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarExcluir=false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
            </template>
        </Dialog>

    </div>
</template>

<script>
import FuncionarioService from '@/service/FuncionarioService';
import CentroCustoService from '@/service/CentroCustoService';
import SaldoBancoHorasService from '@/service/SaldoBancoHorasService';
import ControlePontoService from '@/service/ControlePontoService.js';
import SaldoBancoHoras from '@/model/SaldoBancoHoras';
import Paginacao from '@/components/template/Paginacao.vue';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';
  
  export default {
    controlePontoService: null,
    saldoBancoHorasService: null,
    funcionarioService: null,
    centroCustoService: null,
    data() {
        return {   
            tituloModal: 'Novo Saldo de Banco de Horas',     
            enviandoForm: false,    
            exibirDialogConfirmarExcluir: false,
            exibirDialogNovoSaldo: false,
            exibirDialogSaldos: false, 
            ativo: true,
            mesAno: new Date(),
            idCnpjSelecionado: null,
            cnpjs: [],
            idCentroCustoSelecionado: null,
            centrosCustos: [],
            crachaNome: '',
            funcionarios: [],
            filtro: {},
            qtdLinhasPorPagina: 10,
            numPagina: 1,
            rangeData: '',
            saldos: [],
            datas: [],
            saldoBancoHoras: new SaldoBancoHoras(),
            funcionarioSelecionado: null,
            localeCalendarBR: localeCalendarBR        
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getCacheEmpresa']),
        /**
         * 
         */
        salvar() {
            this.enviandoForm = true;                
			if(this.saldoBancoHoras.horas == null || isNaN(this.saldoBancoHoras.horas) 
                || this.saldoBancoHoras.minutos == null || isNaN(this.saldoBancoHoras.minutos)) {
				return;
			}
            if(this.saldoBancoHoras.horas.toString().length > 5 || this.saldoBancoHoras.minutos.toString().length > 2) {
                exibirMensagemSis(this, 'Limite de carecteres excedido (5):(2)', true);
                return;
            }
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });
            let sbh = {...this.saldoBancoHoras};
            let requisicao = {
                cnpj: cnpjSelecionado,
                funcionario: {
                    id: this.funcionarioSelecionado.id,
                    nome: this.funcionarioSelecionado.nome,
                    pis: this.funcionarioSelecionado.pis
                },
                saldoBancoHoras: sbh,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }			
            this.saldoBancoHorasService.salvar(requisicao)
            .then(resp => {	
                exibirMensagem(this, resp);
                this.exibirDialogNovoSaldo = false;   
                if(resp.data.calcular) {
                    let data = this.saldoBancoHoras.data;
                    this.calcularPeriodoEditado(data, data);
                }                            
                this.listarSaldos();				
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        excluir() {
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });
            let sbh = {...this.saldoBancoHoras};     
			let requisicao = {
                cnpj: cnpjSelecionado,
				saldoBancoHoras: sbh,
                funcionario:  {
                    id: this.funcionarioSelecionado.id,
                    nome: this.funcionarioSelecionado.nome,
                    pis: this.funcionarioSelecionado.pis
                },        
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.saldoBancoHorasService.excluir(requisicao)
            .then(resp => {	
                this.exibirDialogConfirmarExcluir = false;
                exibirMensagem(this, resp);	
                if(resp.data.calcular) {
                    let data = this.saldoBancoHoras.data;
                    this.calcularPeriodoEditado(data, data);
                }
                this.listarSaldos();
            })
            .catch(erro => {exibirMensagem(this, erro)});
		},
        /**
         * 
         */
        calcularPeriodoEditado(dataInicio, dataFinal) {
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });                      
            let requisicao = {
                mes: this.mesAno.getMonth()+1,
                ano: this.mesAno.getFullYear(),
                dataInicio: dataInicio,
                dataFinal: dataFinal,
                cnpj: cnpjSelecionado,
                funcionario:  {
                    id: this.funcionarioSelecionado.id,
                    nome: this.funcionarioSelecionado.nome,
                    pis: this.funcionarioSelecionado.pis
                },      
                usuarioRequisicao: {...this.getDadosRequisicao()},          
            };
            this.controlePontoService.calcularPeriodoEditado2(requisicao)
            .then()
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        selecionar(funcionario) {
            this.funcionarioSelecionado = funcionario;
            this.mesAno = new Date(),
            this.listarSaldos();
            this.exibirDialogSaldos = true;
        },	 
        /**
         * 
         */
        novo() {				
            this.tituloModal = 'Novo Saldo de Banco de Horas';
			this.saldoBancoHoras = new SaldoBancoHoras();
            this.saldoBancoHoras.data = this.datas[0].id;
			this.exibirDialogNovoSaldo = true;            
			this.enviandoForm = false;
        },
        /**
         * 
         */
        editar(saldoBancoHoras) {
			this.enviandoForm = false;
			this.tituloModal = 'Editar Saldo de Banco de Horas';
            this.saldoBancoHoras = {...saldoBancoHoras};                   
            this.exibirDialogNovoSaldo = true;		
        },
        /**
         * 
         */ 
        confirmarExcluir(saldoBancoHoras) {
			this.saldoBancoHoras = saldoBancoHoras;
			this.exibirDialogConfirmarExcluir = true;
		},
        /**
         * 
         */          
        listarSaldos() {
            let requisicao = {
                mes: this.mesAno.getMonth()+1,
                ano: this.mesAno.getFullYear(),
                idFuncionario: this.funcionarioSelecionado.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.saldoBancoHorasService.listar(requisicao)
            .then(resp => {	
                this.datas = [];					
                this.saldos = resp.data.saldos;		
                resp.data.datas.forEach(dt => {
                    this.datas.push({
                        id: dt,
                        nome: this.formatarStringData(dt)
                    });
                })				
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },  
        /**
         * 
         */
        listarPorPagina(paginacao) {
            this.numPagina = paginacao.pagina;
            this.qtdLinhasPorPagina = paginacao.linhas;
            this.listar();
        },
        /**
         * 
         */
        listarPorFiltros() {
            this.numPagina = 1;
            this.$refs.paginacao.paginar(1);
        },      
        /**
         * 
         */   
        listar() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let requisicao = {
                qtdLinhas: this.qtdLinhasPorPagina,
                numPagina: this.numPagina,
                crachaNome: this.crachaNome,
                ativo: this.ativo,
                idsCentrosCustos: idsCentrosCustos,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.funcionarioService.listar(requisicao)
            .then(resp => {                   
                this.$refs.paginacao.atualizar(resp.data.qdtFuncionarios);                       
                this.funcionarios = resp.data.funcionarios;
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        }, 
        /**
         * 
         */  
        listarCnpjs() {
            if(this.cnpjs.length > 0) {
                return;
            }
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         * 
         */
        listarCentrosCustos() {
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {                       
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);                    
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },        
        /**
         * 
         */
        formatarStringData(data) {
            if(!data || data instanceof Date) {
                return '';
            }
			let partes = data.split('-');
			return partes[2] + '/' + partes[1] + '/' + partes[0];
		},
        /**
         * 
         */
        formatarData(data) {
            if(!data) {
                return null;
            }
            let strData = null;
            if(data instanceof Date) {
                let dt = data;
                let mes = dt.getMonth();
                let dia = dt.getDate();
                strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
            } else {
                let partes = data.split('/');
                strData = partes[2] + '-' + partes[1] + '-' + partes[0];
            }
            return strData;
        },
        /**
         * 
         */
        formatarHoras(saldoBH) {
            let valor = '';
            let horas = saldoBH.horas < 10 ? '0'+saldoBH.horas : saldoBH.horas;
            let minutos = saldoBH.minutos < 10 ? '0'+saldoBH.minutos : saldoBH.minutos;
            if(saldoBH.valorNegativo) {
                valor = '-'+horas+':'+minutos;
            } else {
                valor = horas+':'+minutos;
            }
            return valor;
        },
        /**
         * 
         */
        limitarMinutos() {
            if(this.saldoBancoHoras.minutos != null) {               
                this.saldoBancoHoras.minutos = Number(this.saldoBancoHoras.minutos.toString().replace(/\D/g,'').substring(0, 2));
            } else {
                this.saldoBancoHoras.minutos = 0;
            }
        },
        /**
         * 
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+1);     
        },
        /**
         * 
         */
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(121);
			this.permissaoEditar = permissoes.includes(122);
			this.permissaoExcluir = permissoes.includes(123);			
		}
    },	
    created() {
        this.controlePontoService = new ControlePontoService();
        this.saldoBancoHorasService = new SaldoBancoHorasService();
        this.funcionarioService = new FuncionarioService();		
        this.centroCustoService = new CentroCustoService();		
    },
    mounted() {	
        this.validarPermissoes();	
        this.criarRangeData();
        this.listarCnpjs();			
    },
    components: {
        'Paginacao': Paginacao,
    }
}
</script>

<style>

</style>